module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    class: _vm.classes
  }, [_c(_vm.subComponent, {
    tag: "component",
    attrs: {
      "params": _vm.params,
      "model": _vm.model,
      "item": _vm.item,
      "column": _vm.column,
      "duplicateDescriptionText": _vm.$t('models.duplicate_desc')
    },
    on: {
      "itemDelete": _vm.itemDelete
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4190365e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/helpers/DataDisplay/CollectionValue.vue
// module id = 1880
// module chunks = 0